import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'View',
				id: 'view',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.apkUpdateInfo,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].viewSubAppUpdateLogs,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
